export function Logo({ className = "h-8", variant = "full", ...rest }) {
    const src = variant === "mark" ? "/phase2labs-mark.png" : "/phase2labs-logo.png";
    return <img src={src} alt="Phase 2 Labs Marketing" className={className} {...rest} />;
}

export default Logo;
